import styled from 'styled-components';
export const NavItemWrapper = styled.li `
  position: relative;
`;
export const NavItemLink = styled.span `
  cursor: pointer;
  position: relative;
`;
export const TabTitle = styled.span `
  position: relative;
`;
export const TabIcon = styled.span `
  position: relative;
`;
